import { NextSeo } from 'next-seo';

export default function SeoCommon({ title, description }: { title: string; description: string }) {
    return <NextSeo title={title} description={description} />;
}
